// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606150816/js/" + chunkId + "." + {"44":"a17aa16a","225":"4e2e9e50","481":"a7c03707","486":"778a2404","770":"712037b7"}[chunkId] + ".0.481105279096526.chunk.js";
};